import { clsx } from 'clsx';
import { ElementType, ReactNode } from 'react';

import { Heading } from 'src/components/mainComponents/Heading';

import './Paper.scss';

type PaperProps<T extends ElementType> = {
  as?: T;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  fullWidth?: boolean;
};

type PaperTitleProps = { children: ReactNode };
type PaperActionsProps = { children: ReactNode };

export function Paper<T extends ElementType = 'div'>({
  as,
  children,
  className: additionalClassName = '',
  noPadding = false,
  fullWidth = true,
  ...htmlAttributes
}: PaperProps<T>) {
  const Component = as ?? 'div';
  const className = clsx(
    'Paper',
    {
      'Paper--no-padding': noPadding,
      'Paper--full-width': fullWidth,
    },
    additionalClassName
  );

  return (
    <Component className={className} {...htmlAttributes}>
      {children}
    </Component>
  );
}

const PaperTitle = (props: PaperTitleProps) => {
  return (
    <Heading level={4} as='h4' className='Paper__title'>
      {props.children}
    </Heading>
  );
};
Paper.Title = PaperTitle;

const PaperActions = (props: PaperActionsProps) => {
  return <div className='Paper__actions'>{props.children}</div>;
};
Paper.Actions = PaperActions;
